// @ts-nocheck
import { createService } from "@/integration/factory/service-factory.ts";
import { ITeamActivity, ITeamActivityPaginated, TeamActivityType } from "../interfaces/team-activity.interface";

/**
 * Service for team activity-related API calls
 */
export default function teamActivityService() {
  // Create base services for team activity endpoints
  const teamsService = createService("/teams");

  /**
   * Get team activities with pagination
   * @param teamId The team ID
   * @param page Page number (default: 1)
   * @param limit Items per page (default: 10)
   * @param actionType Optional filter by activity type
   * @param timeFilter Optional filter by time period in days (e.g., 7 for last 7 days)
   * @returns Paginated team activities
   */
  const getTeamActivities = async (
    teamId: string,
    page: number = 1,
    limit: number = 10,
    actionType?: TeamActivityType,
    timeFilter?: number
  ): Promise<ITeamActivityPaginated> => {
    try {
      const params = {
        page,
        limit,
        ...(actionType && { actionType }),
        ...(timeFilter && { timeFilter }),
      };

      return await teamsService.customGet<ITeamActivityPaginated>(
        `/${teamId}/activities`,
        { params }
      );
    } catch (error) {
      console.error("Error fetching team activities:", error);
      // Return a default empty response instead of propagating the error
      return {
        data: [],
        page,
        limit,
        total: 0,
        totalPage: 0,
      } as ITeamActivityPaginated;
    }
  };

  /**
   * Get a specific team activity by ID
   * @param teamId The team ID
   * @param activityId The activity ID
   * @returns The team activity
   */
  const getTeamActivityById = async (
    teamId: string,
    activityId: string
  ): Promise<ITeamActivity | null> => {
    try {
      return await teamsService.customGet<ITeamActivity>(
        `/${teamId}/activities/${activityId}`
      );
    } catch (error) {
      console.error("Error fetching team activity:", error);
      return null;
    }
  };

  return {
    getTeamActivities,
    getTeamActivityById,
  };
}
